<template>
  <div class="day-to-day">
    <el-row justify="center" class="day-day-titles mt-5">
      <el-col align="center">
        <div v-html="data.dayFirstCall"></div>
      </el-col>
    </el-row>

    <el-row justify="center mt-5">
      <el-col :span="22" align="center">
        <el-row class="vacation" justify="center" align="middle">
          <el-col align="right" :span="10">
            <div class="vacation-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../../assets/icons/vacation.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="14">
            <el-row justify="center" class="vacation-titles mt-5">
              <el-col align="left">
                <div v-html="data.dayFerias"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row justify="center" class="day-day-titles second-text mt-5">
      <el-col align="center">
        <div v-html="data.daySecondCall"></div>
      </el-col>
    </el-row>

    <el-row justify="center" class="workhour mt-5">
      <el-col align="center" :span="22">
        <figure>
          <img
            class="premios"
            alt="Vue logo"
            :src="data.imgFerias"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center mt-5">
      <el-col :span="22" align="center">
        <el-row class="benfits" justify="center" align="middle">
          <el-col align="right" :span="5">
            <div class="vacation-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../../assets/images/persons/relogio.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="19">
            <el-row justify="center" class="bench mt-5">
              <el-col align="left">
                <div v-html="data.bancoDeHoras"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="benfits" justify="center" align="middle">
          <el-col align="right" :span="5">
            <div class="vacation-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../../assets/images/persons/empresa.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="19">
            <el-row justify="center" class="bench">
              <el-col align="left">
                <div v-html="data.acessoEmpresa"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- <el-row justify="center" class="day-day-titles mt-5">
      <el-col align="center">
        <h4>Encarreiramento, Meritocracia e Promoção</h4>
        <p>
          A Política de Encarreiramento e Meritocracia é constituída pelo
          conjunto de regras, normas e critérios definidos pela empresa para
          orientar a evolução de carreira de seus colaboradores.
        </p>
      </el-col>
    </el-row>

    <el-row justify="center mt-5">
      <el-col :span="22" align="center">
        <el-row class="benfits" justify="center" align="middle">
          <el-col align="right" :span="5">
            <div class="vacation-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../../assets/images/persons/alvo.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="19">
            <el-row justify="center" class="bench">
              <el-col align="left">
                <div v-html="data.objetivos"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="benfits" justify="center" align="middle">
          <el-col align="right" :span="5">
            <div class="vacation-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../../assets/images/persons/troca.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="19">
            <el-row justify="center" class="bench">
              <el-col align="left">
                <div v-html="data.carreira"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="benfits" justify="center" align="middle">
          <el-col align="right" :span="5">
            <div class="vacation-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../../assets/images/persons/caminho.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="19">
            <el-row justify="center" class="bench">
              <el-col align="left">
                <div v-html="data.cargos"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="benfits" justify="center" align="middle">
          <el-col align="right" :span="5">
            <div class="vacation-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../../assets/images/persons/medalha.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="19">
            <el-row justify="center" class="bench">
              <el-col align="left">
                <div v-html="data.meritos"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row> -->

    <div class="close-btn-text mt-5 mb-5" @click="$emit('close-service')">Fechar</div>
  </div>
</template>

<script>
export default {
  name: 'Day',
  props: ['data']
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.day-to-day {
  ul {
    list-style: none; /* Remove default bullets */
  }

  ul li::before {
    content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
    color: $green; /* Change the color */
    font-weight: bold; /* If you want it to be bold */
    display: inline-block; /* Needed to add space between the bullet and the text */
    width: 1em; /* Also needed for space (tweak if needed) */
    margin-left: -1em; /* Also needed for space (tweak if needed) */
  }

  li {
    font-size: 1.4rem;
    text-transform: none;
  }
  h4 {
    margin-top: 4rem;
  }
}

.bench {
  li {
    font-size: 1rem;
    text-transform: capitalize;
  }

  h4 {
    font-size: 1.8rem;
    text-transform: uppercase;
    line-height: 4rem;
    color: $green;
    font-weight: 400;
  }

  p {
    margin: 1.5rem 0;
    font-size: 1rem;
  }
}
.day-day-titles,
.vacation-titles,
.clientes-titles {
  text-transform: uppercase;

  h3 {
    font-weight: bold;
    color: $green;
    max-width: 60%;
    font-size: 3rem;
    line-height: 4rem;
    margin-bottom: 5rem;
  }

  h4 {
    font-size: 3rem;
    line-height: 4rem;
    color: $green;
    font-weight: 300;
  }

  h5 {
    font-weight: bold;
    font-size: 1.8rem;

    line-height: 4rem;
    color: $green;
    font-weight: 300;
  }

  p {
    padding-top: 2rem;
    text-transform: none;
    width: 60%;
  }
}

.vacation, .benfits {
  padding-bottom: 3rem;
  background-color: $white;
}

.benfits{
  padding-bottom: 1rem;
}

.vacation-image {
  padding: 5rem;
  img {
    width: 100%;
  }
}

.vacation-titles {
  p {
    font-size: 1.2rem;
    width: 100%;
  }
}
.vacation-infos {
  margin: 1.3rem;
  color: $green;
}

.workhour {
  img {
    width: 100%;
  }
}

.clientes-titles {
  color: $purple
}
</style>
